import { render, staticRenderFns } from "./April_2022.vue?vue&type=template&id=997a47b4&scoped=true&"
import script from "./April_2022.vue?vue&type=script&lang=js&"
export * from "./April_2022.vue?vue&type=script&lang=js&"
import style0 from "./April_2022.vue?vue&type=style&index=0&id=997a47b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997a47b4",
  null
  
)

export default component.exports